export const DROPDOWNS_FIELD_NAMES = {
  CALLING_DISPATCH_CONTAINER: "CALLING_DISPATCH_CONTAINER",
  CLIENTS_BILLING_ADDRESS: "CLIENTS_BILLING_ADDRESS",
  CLIENT_SENDING_PRODUCTS: "CLIENT_SENDING_PRODUCTS",
  SPECIFIC_PURCHASE_REQUIRED: "SPECIFIC_PURCHASE_REQUIRED",
  CURRENCY: "CURRENCY",
  DISPATCH_PLAN_CLARITY: "DISPATCH_PLAN_CLARITY",
  DISPATCH_TERMS: "DISPATCH_TERMS",
  EARLY_DELIVERY: "EARLY_DELIVERY",
  MID_PROJECT_MILESTONES: "MID_PROJECT_MILESTONES",
  PCD_TYPE: "PCD_TYPE",
  PRODUCTION_TYPE: "PRODUCTION_TYPE",
  PROJECT_END_SCOPE: "PROJECT_END_SCOPE",
  PROTO_CATEGORY: "PROTO_CATEGORY",
  SAMPLE_FINISH_DEVELOPMENT_REQUIRED: "SAMPLE_FINISH_DEVELOPMENT_REQUIRED",
  SHOP_DRAWING_CATEGORY: "SHOP_DRAWING_CATEGORY",
  THINGS_IN_CLIENT_SCOPE: "THINGS_IN_CLIENT_SCOPE",
  SPECIFIC_REQUIREMENT_METAL: "SPECIFIC_REQUIREMENT_METAL",
  SPECIFIC_REQUIREMENT_TEAK_WOOD: "SPECIFIC_REQUIREMENT_TEAK_WOOD",
  SITE_MEASUREMENT_REQUIRED: "SITE_MEASUREMENT_REQUIRED",
  APPROVED_QUOTATION: "APPROVED_QUOTATION",
  PO: "PO",
  ADVANCE_RECEIVED: "ADVANCE_RECEIVED",
  ADVANCE_CONFIRMATION: "ADVANCE_CONFIRMATION",
  DESIGN_DRAWINGS_DESIGN_SCOPE_FROM_CLIENT:
    "DESIGN_DRAWINGS_DESIGN_SCOPE_FROM_CLIENT",
  PRODUCT_TO_PCD_CODE_MAPPING: "PRODUCT_TO_PCD_CODE_MAPPING",
  DISPATCH_DATE_CONFIRMATION: "DISPATCH_DATE_CONFIRMATION",
  SHORT_TIMELINE_APPROVALS: "SHORT_TIMELINE_APPROVALS",
  PYTHA_HANMAC_SHOP_DRAWING_APPROVAL_FROM_SK:
    "PYTHA_HANMAC_SHOP_DRAWING_APPROVAL_FROM_SK",
  ANY_OTHER_PROJECT_NOTES: "ANY_OTHER_PROJECT_NOTES",
};
